import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { HotkeysService } from 'src/app/services/hotkeys.service';

export interface DialogData {
  text: string;
  title: string;
  okText: string;
  cancelText: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    standalone: false
})
export class ConfirmDialogComponent extends UnsubscriberComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private hotkeys: HotkeysService) { super(); }

  ngOnInit(): void {
    this.subscriptions.add(
      this.hotkeys.addShortcut({ keys: 'y' }).subscribe(() => {
        this.dialogRef.close(true);
      })
    );
    this.subscriptions.add(
      this.hotkeys.addShortcut({ keys: 'n' }).subscribe(() => {
        this.dialogRef.close(false);
      })
    );
  }

}
